/* TODO: This lovely grid came from NextGen (https://bitbucket.org/haymarketautomotive/aphrodite-frontend/src/master/)
 * and has been cut down from the original to fit the minimal needs of DRIVE.
 * This will be made a shared component in Olympus and when this is done we should delete this and pull from there.
 */

// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from '../Grid.scss';
import { getResponsiveClasses } from '../gridFunctions';

/**
 *	Row React presentational component.
 */
class Row extends Component<*, *> {
  /**
   *	A props mapping array for alignment classes.
   * @return {Array}
   *   - An array of row alignment types.
   */
  getAlignmentKeys = () => {
    return [
      'top',
      'middle',
      'bottom',
      'around',
      'between',
      'start',
      'center',
      'end',
      'reverse'
    ];
  };

  /**
   * Gets the grid row classes for alignment of rows.
   * Filters out all props by alignment keys using getAlignmentKeys().
   * @return {Array}
   * - A style class.
   */
  getRowAlignmentClasses = () => {
    return this.getAlignmentKeys()
      .filter(item => this.props[item])
      .map(item => getResponsiveClasses('row', item, this.props[item]));
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render() {
    if (!this.props.children) {
      return null;
    }

    const alignmentClasses = this.getRowAlignmentClasses();
    const rowClasses = classNames([
      styles.row,
      alignmentClasses,
      this.props.className
    ]);

    return (
      <div style={this.props.style} className={rowClasses}>
        {this.props.children}
      </div>
    );
  }
}

export default Row;



// WEBPACK FOOTER //
// ./src/components/Grid/Row/index.js